import React from "react";

const About = () => {
  return (
    <div className="about-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 align-self-center">
            <div className="section-title mb-lg-0">
              <h2 className="title">
                Povijest <br /> Prokuratora
              </h2>
              <p>
                  Tvrtka Prokurator d.o.o. osnovana je 02. veljače 2012. na
                  Trgovačkom sudu u Splitu. Sjedište je i danas Split. Kroz
                  godine smo izgradili mrežu vanjskog oglašavanja i digitalni
                  marketing — danas oboje radimo ravnopravno: SEO
                  optimizaciju, Google Ads, vođenje društvenih mreža i izradu
                  web stranica, uz 500+ oglasnih površina na najprometnijim
                  ulicama diljem Hrvatske. Tim od 9 izravnih i 15 neizravnih
                  suradnika povezuje online kampanje i plohe formata bigboard,
                  billboard, wallscape, putokazi i drugi formati.
                </p>
            </div>
          </div>
          <div className="col-lg-5 offset-lg-2">
            <div className="thumb about-section-right-thumb">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/prokurator-web.appspot.com/o/9.png?alt=media&token=1367a68a-30c9-4a65-a688-500fe8c79ce3"
                alt="img"
              />
              <img
                className="about-absolute-thumb"
                src="https://firebasestorage.googleapis.com/v0/b/prokurator-web.appspot.com/o/10.png?alt=media&token=ee5d1c28-644b-415c-beec-53bae47cceca"
                alt="img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
